import React from 'react';
import '../App2.css'; // Asegúrate de que los estilos estén en tu archivo CSS principal

const Modal = ({ isOpen, onRequestClose, title, children, footer }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="close-button" onClick={onRequestClose}>X</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
